module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fm-title"
  }, [_c('span', {
    staticClass: "bbold"
  }, [_vm._v("Table of Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/fm04"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Preface")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/fm04#sec1"
    }
  }, [_vm._v("Setting the Cultural, Social, and Business Context")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/fm04#sec2"
    }
  }, [_vm._v("The Power of a False Message")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/fm04#sec3"
    }
  }, [_vm._v("Data Gone Big and Good Data Gone Bad")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/fm05"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chap01"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 1. Foundation Blocks")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chap01#sec1"
    }
  }, [_vm._v("PD + HW + E + GL = GS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chap01#sec2"
    }
  }, [_vm._v("Good Lesson Affirmation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chap01#sec3"
    }
  }, [_vm._v("Good Lesson Perspectives: Building Upon the Good Lesson Affirmation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chap01#sec4"
    }
  }, [_vm._v("Become a Good Leader by Recognizing Bad Ones")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chap01#sec5"
    }
  }, [_vm._v("Bad Leader as Thief")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chap01#sec6"
    }
  }, [_vm._v("Internal Constraint vs. External Restraint")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chap01#sec7"
    }
  }, [_vm._v("Evaluating the Leader as Bad: The Good Way to Do It")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chap01#sec8"
    }
  }, [_vm._v("Eight Questions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chap01#sec9"
    }
  }, [_vm._v("Trending to or from G.R.A.C.E.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chap01#sec10"
    }
  }, [_vm._v("Capitalize on Your G.R.A.C.E. to Overcome Your Lack of Experience")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chap01#sec11"
    }
  }, [_vm._v("Transparency: Distinguishing the Good from the Bad")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chap01#sec12"
    }
  }, [_vm._v("Reactive Protection")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chap01#sec13"
    }
  }, [_vm._v("Bad Bus Driver: Revisiting the "), _c('i', [_vm._v("Good to Great")]), _vm._v(" Bus Metaphor")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chap01#sec14"
    }
  }, [_vm._v("Defining a Lesson")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chap01#sec15"
    }
  }, [_vm._v("Defining a “Good” Lesson")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chap01#sec16"
    }
  }, [_vm._v("Defining a “Bad” Leader")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chap01#sec17"
    }
  }, [_vm._v("What Makes a Bad Leader Bad?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chap01#sec18"
    }
  }, [_vm._v("Current Reality")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chap01#sec19"
    }
  }, [_vm._v("AMAP with ALRAP-ASAP")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chap01#sec20"
    }
  }, [_vm._v("Learning to See the Good Lesson")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chap01#sec21"
    }
  }, [_vm._v("Inability, Willingness, and Refusal")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chap01#sec22"
    }
  }, [_vm._v("Asking the Question")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chap01#sec23"
    }
  }, [_vm._v("Incompetency Abounds")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chap01#sec24"
    }
  }, [_vm._v("Summary Statement")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chap01#sec25"
    }
  }, [_vm._v("So, What Are You Going to Do?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chap01#sec26"
    }
  }, [_vm._v("Recommendations to Extract Value")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 2 Good Lessons: Inability")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap02#sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Inability to Tell the Whole Truth")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap02#sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Inability to Create and Maintain a Spirit of Fair Exchange")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap02#sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Inability to Take Courage")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap02#sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Inability to Springboard from NOORTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap02#sec5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Inability to Share in the Meaningful Achievements of Others")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap02#sec6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Inability to Use Brakes and Accelerator Properly")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap02#sec7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Inability to Avow or Engage Approachability")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap02#sec8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Inability to Deploy Ice Cream")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap02#sec9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Inability to Model Loyalty and Ride for the Brand")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap02#sec10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Inability to Let People Off the Hook Strategically")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap02#sec11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Inability to Read Between the Lines Effectively")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap02#sec12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Inability to Use Talented Personnel Wisely")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap02#sec13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Inability to Promote Unity and Diversity")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap02#sec14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Inability to Connect Organizational and Personal Benefits")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap02#sec15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Inability to Leverage Teaching Moments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap02#sec16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Inability to Endear Themselves")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap02#sec17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Inability to Use Humor Productively")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap02#sec18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Inability to Blend Intuition, Emotion, and Reason in Decision Making")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap02#sec19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Inability to Be Comfortable in Uncomfortable Circumstances")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap02#sec20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Inability to Release Prior Success")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap02#sec21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Inability to Anticipate Conditions and Intentions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap02#sec22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Inability to Distinguish Truths")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 3 Good Lessons: Willingness")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap03#sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Willingness to Tolerate Inconsistency")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap03#sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Willingness to Enable Covetousness")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap03#sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Willingness to Impoverish")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap03#sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Willingness to Bail Out and Abandon")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap03#sec5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Willingness to Provoke Purposefully")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap03#sec6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Willingness to Overcommit")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap03#sec7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Willingness to Manage Problems Rather Than Solve Them")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap03#sec8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Willingness to Use Conflicting Messages")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap03#sec9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Willingness to Strike Back")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap03#sec10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Willingness to Prevent Consensus-Created Inactivity")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap03#sec11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Willingness to Tolerate Organizational Imbalance")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap03#sec12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Willingness to Extend Earned Privilege to Abuse of Privilege")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap03#sec13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Willingness to Improperly Conduct Meetings")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap03#sec14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Willingness to Understate or Overstate Role as Influencer")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap03#sec15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Willingness to Use False Narratives as Motivators")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 4 Good Lessons: Refusal")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap04#sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Refusal to Take Responsibility for Financial Failure")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap04#sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Refusal to Create Direction, Momentum, and Detail")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap04#sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Refusal to Admit Bias")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap04#sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Refusal to Use a Reverse Gear")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap04#sec5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Refusal to Loaf Creatively")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap04#sec6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Refusal to Acknowledge Role in Success and Failure")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap04#sec7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Refusal to Take Responsibility for Organizational Culture")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap04#sec8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Refusal to Provide Covering Fire")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap04#sec9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Refusal to Steadfastly Engage Performance Evaluations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap04#sec10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Refusal to Make Decisions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap04#sec11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Refusal to Become a Datapreneuer")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap04#sec12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Refusal to Play Role of Mediator and Lead Reconciliation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap04#sec13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Refusal to Prevent or Mitigate Cybercrime")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap04#sec14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Refusal to Provide an Escape Route")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap04#sec15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Refusal to Recognize the Cost of Value Production")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 5 Judging Wisely: Setting Yourself Apart")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 6 Looking Ahead")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap06#sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Determination to Unburden Oneself")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap06#sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Leadership in the World of Big Automation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap06#sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sapience and Sentience")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap06#sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The “Can I”/“Should I” Dilemma")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap06#sec5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Who’s in Charge in the A/R World? Give Back and Take Back Role Confusion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap06#sec6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Road Ahead")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap06#sec7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Too Small for Your Britches and the Role of EI in Good Leadership")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap06#sec8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lessons Regarding Passion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap06#sec9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lessons Regarding Covenant")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Conclusion")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm01#sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Running the Table")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm01#sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Commit to Grit")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("About the Author")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Endnotes")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a01b224c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 78
// module chunks = 0